export default __webpack_public_path__ + "static/media/shopping-cart.f70044dd.svg";